import { render } from "./RequestView.vue?vue&type=template&id=1ef0b102"
import script from "./RequestView.vue?vue&type=script&lang=js"
export * from "./RequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__